module.exports = __webpack_public_path__ + "static/media/drvspace_1.15534dec.ico";